var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAppDispatch } from 'root/src/client/logic/helpers/useStore';
import { useMutation } from '@tanstack/react-query';
import getFileHash from 'root/src/client/util/getFileHash';
import uploadFile from 'root/src/client/util/uploadFile';
export function useUploadFileMutation() {
    const dispatch = useAppDispatch();
    return useMutation({
        mutationKey: ['uploadFile'],
        mutationFn: (file, ttl = 1440) => __awaiter(this, void 0, void 0, function* () {
            const fileHash = yield getFileHash(file);
            const filePath = yield uploadFile(file, dispatch, ttl);
            const fileName = file.name;
            const url = `https://${filePath}`;
            return {
                url,
                fileName,
                fileHash,
            };
        }),
    });
}
